module.exports = __webpack_public_path__ + "static/img/capitania_mayor.2a7e03e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capitania_mayor.jpg
// module id = dfh6
// module chunks = 0